import { useEffectOnce, useQueryState, useUpdateEffect } from 'core/use-cases/utilities';

import { useCatalogCommand } from '../commands';
import { useCatalogSelector, useNotFoundSelector } from '../selectors';

import type { Catalog } from 'core/domains';

export function useCatalog(queryOptions: Catalog['queryOptions']) {
  const { cleanCatalog, getCatalog } = useCatalogCommand();

  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useCatalogSelector);

  useEffectOnce(() => {
    getCatalog(queryOptions);

    return () => {
      cleanCatalog();
    };
  });

  useUpdateEffect(() => {
    getCatalog(queryOptions);
  }, [queryOptions]);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

export function useNotFound() {
  return useNotFoundSelector();
}
